const changePwTypeMixin = {
  methods: {
    // 비밀번호 눈표시 클릭 이벤트
    changePwType(event) {
      const thisEl = event.target; // 눈 버튼
      const previousEl = event.target.previousElementSibling; // 비밀번호 input

      if (thisEl.classList.contains('hide')) {
        thisEl.classList.remove('hide');
        previousEl.type = 'password';
      } else {
        thisEl.classList.add('hide');
        previousEl.type = 'text';
      }
    },
  }
}

export default changePwTypeMixin;